module.exports = __webpack_public_path__ + "screenshot.75646858b8a1e2e65063b7b19df1e3f3.png";